<template>
  <div class="login">
    <!-- 登录面板 -->
    <div class="login-box">
      <div class="login-box-title">后台管理系统</div>
      <div class="login-box-from">
        <el-form
          :model="loginForm"
          :rules="rules"
          ref="loginForm"
          class="demo-ruleForm"
        >
          <el-form-item prop="username" >
            <el-input
              v-model="loginForm.username"
              placeholder="请输入用户名"
              size="medium"
            >
              <el-button slot="prepend" icon="el-icon-user"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              placeholder="请输入密码"
              size="medium"
              type="password"
            >
              <el-button slot="prepend" icon="el-icon-key"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="code" class="yzm">
            <el-input
              placeholder="验证码"
              v-model="loginForm.code"
              style="width: 150px"
            >
              <el-button
                slot="prepend"
                icon="el-icon-edit-outline"
              ></el-button>
            </el-input>
            <div class="coderight" @click="makeCode">
              <img :src="'data:image/jpeg;base64,' + codeImg" alt="" />
              <!--<SIdentify v-if="identifyCodes" :identifyCode="identifyCode"></SIdentify>-->
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              :loading="btnLoading"
              style="width: 100%"
              @click="submitForm('loginForm')"
              >立即登陆
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { login, codes } from "@/api/api";
import local from "@/utils/local";
import Qs from 'qs'
export default {
  data() {
    let letterRule = (rule, value, callback) => {
      let reg = /^[a-zA-Z0-9_-]{4,18}$/;
      if (value === "") {
        callback(new Error("输入内容不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入字母、数字、下划线"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      btnLoading: false,
      codeImg: "",
      loginForm: {
        // 登陆表单
        username: "",
        password: "",
        code: "",
      },

      rules: {
        //登陆验证规则
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
          // {validator: letterRule, trigger: 'blur'}
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
          { validator: letterRule, trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  created() {
    this.makeCode();
  },
  methods: {
    async makeCode() {
      let { code, data } = await codes();
      if (code == 200) {
        this.codeImg = data;
      }
      this.loading = false;
    //   console.log(code, data);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.login();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async login() {
      // console.log(this.loginForm.username)
      this.btnLoading = false;
      let { code, data,msg } = await login(Qs.stringify(this.loginForm));
      if (code == 200) {
              this.$message({
            type: 'success',
            message: '登录成功,即将为您跳转至登录页面！'
        })
        local.set("id", data.id);
        local.set("t_k", data.token);
        local.set("name", data.name);
        local.set("username", data.username);
        setTimeout((_) => {
          this.btnLoading = false;
          this.$router.push("/");
        }, 1500);
      }
    },
  },
};
</script>
<style lang="less">
.yzm {
  .el-form-item__content {
    display: flex;
    align-items: center;
  }

  .coderight {
    height: 40px;
    margin-left: 13px;
    overflow: hidden;
    border-radius: 4px;

    img {
      width: 135px;
      height: 40px;
    }
  }
}
</style>
<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("../../assets/img/login.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .login-box {
    width: 350px;
    /* height: 287px; */
    background: hsla(0, 0%, 100%, 0.3);
    border-radius: 5px;
    box-shadow: 0 0 2px #f7f7f7;
    border: 1px solid #f7f7f7;
  }

  .login-box-title {
    line-height: 50px;
    font-size: 20px;
    color: #ffffff;
    text-align: center;
    border-bottom: 1px solid #ffffff;
  }

  .login-box-from {
    width: 100%;
    height: auto;
    padding: 30px;
    box-sizing: border-box;
  }
}
</style>
